// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"361":"e6b75fd3","7214":"e4d0b000"}[chunkId] || chunkId) + "." + {"361":"f5fed71598748365","863":"b4e8f0c5444b3b46","2406":"c3eaae6ce9c59167","4566":"9bcceaea8800aa08","7214":"2bcd81c410ef6aa9","9157":"f88615adfcc99f50"}[chunkId] + ".js";
};